import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { StatusBadge } from "@/components/StatusBadge";
import { fmtMoney, fmtDate } from "@/lib/helpers";

export default function AdminRFQs() {
  const [rfqs, setRfqs] = useState([]);
  useEffect(() => { api.get("/admin/rfqs").then((r) => setRfqs(r.data)).catch(() => {}); }, []);

  return (
    <div className="p-6 md:p-8 max-w-7xl">
      <div className="label-tech text-muted-foreground mb-1">Demand oversight</div>
      <h1 className="text-3xl font-bold tracking-tight">All RFQs</h1>

      <div className="mt-6 border border-border rounded-sm overflow-hidden bg-card">
        <div className="hidden md:grid grid-cols-12 gap-4 px-5 py-3 border-b border-border label-tech text-muted-foreground bg-secondary/50">
          <div className="col-span-4">Part</div>
          <div className="col-span-3">Buyer</div>
          <div className="col-span-2 text-right">Est. value</div>
          <div className="col-span-1 text-center">Quotes</div>
          <div className="col-span-2 text-right">Status</div>
        </div>
        {rfqs.length === 0 && <div className="px-5 py-12 text-center text-sm text-muted-foreground">No RFQs yet.</div>}
        {rfqs.map((r) => (
          <Link key={r.id} to={`/rfqs/${r.id}`} data-testid={`admin-rfq-row-${r.id}`} className="grid grid-cols-2 md:grid-cols-12 gap-2 md:gap-4 px-5 py-4 border-b border-border last:border-0 items-center hover:bg-secondary/50 transition-colors">
            <div className="col-span-2 md:col-span-4 min-w-0">
              <div className="font-medium truncate">{r.title}</div>
              <div className="text-xs font-mono text-muted-foreground">{r.process} · Qty {r.quantity} · {fmtDate(r.created_at)}</div>
            </div>
            <div className="hidden md:block col-span-3 text-sm truncate">{r.buyer_company || r.buyer_name}</div>
            <div className="hidden md:block col-span-2 text-right font-mono text-sm">{fmtMoney(r.instant_estimate?.total_price)}</div>
            <div className="hidden md:block col-span-1 text-center font-mono text-sm">{r.quote_count}</div>
            <div className="col-span-2 flex justify-end"><StatusBadge status={r.status} /></div>
          </Link>
        ))}
      </div>
    </div>
  );
}
